import React, {
  Dispatch,
  ForwardedRef,
  SetStateAction,
  useMemo,
  useRef,
} from 'react';
import { Icon, Label, PositionX, PositionY } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { OperationsFilesCardMenu } from './OperationsFilesCardMenu';
import {
  CustomDropdownAsset,
  FilesOptionListInfo,
  filesOptionMenuInfo,
  imageTypes,
} from '../model';
import { OptionMenuItemStyles, OptionMenuStyles } from '../Styles';

type DropdownFilesCardProps = {
  assets: CustomDropdownAsset[];
  onClick: Dispatch<SetStateAction<number | null>>;
  contentType: string;
  loading: boolean;
};

export const DropdownFilesCard = ({
  assets,
  onClick,
  contentType,
  loading,
}: DropdownFilesCardProps) => {
  const { t } = useTranslation();
  const filesCardMenuRef = useRef<null>(null);

  const infoByContent: FilesOptionListInfo = useMemo(
    () => filesOptionMenuInfo[contentType],
    [contentType],
  );

  const { menuTitle, menuIconLeft, menuIcon, assetName, assetIcon } =
    infoByContent;

  const getAsset = (type: string) => (
    <>
      {assetIcon && <Icon iconName={assetIcon} size="16" />}
      <Label fontSize="14" semibold>
        {!imageTypes.includes(contentType) ? t(assetName) : t(type)}
      </Label>
    </>
  );

  const ForwardedFilesCardMenu = React.forwardRef(
    (props, ref: ForwardedRef<null>) => (
      <OperationsFilesCardMenu
        innerRef={ref}
        title={menuTitle}
        iconLeft={menuIconLeft}
        icon={menuIcon && <Icon iconName={menuIcon} size="24" />}
        loading={loading}
        assetsNumber={assets.length}
        {...props}
      />
    ),
  );
  return (
    <OptionMenuStyles
      positionX={PositionX.start}
      positionY={PositionY.bottom}
      renderItem={<ForwardedFilesCardMenu ref={filesCardMenuRef} />}
      widthAuto={false}
      hidePanelOnClick
    >
      {assets.map((asset: CustomDropdownAsset, index: number) => (
        <OptionMenuItemStyles
          key={index}
          onClick={() => onClick(asset.position)}
        >
          {getAsset(asset.type)}
        </OptionMenuItemStyles>
      ))}
    </OptionMenuStyles>
  );
};
